module.exports = __webpack_public_path__ + "img/kootto_private_chef_plate_400.6e9cf355.webp";